import { Button, Stack } from '@mui/material';
import FolderOpenOutlined from '@mui/icons-material/FolderOpenOutlined';
import { DataTable } from '../../components/DataTable';
import { useNotice } from '../../components/NoticeProvider';
import { SrbCode } from '../../components/SrbCode';
import { StatusChip } from '../../components/StatusChip';
import { shortDate } from '../../lib/dates';
import { FINDER_NOTICE, useCanOpenFinder } from '../../lib/finder';
import { FileIcon } from './FileIcon';
import { DOC_STATUS_TONE, type DocRecord } from './sample';

type Props = { rows: DocRecord[]; onOpen: (r: DocRecord) => void; empty?: string };

/** The document records as a table (cards on a phone). A click opens the record. */
export function DocumentsTable({ rows, onOpen, empty = 'No documents match.' }: Props) {
  const notice = useNotice();
  const canFinder = useCanOpenFinder();
  return (
    <DataTable<DocRecord>
      rows={rows}
      rowKey={(r) => r.id}
      empty={empty}
      onRowClick={onOpen}
      columns={[
        {
          header: 'Document Name',
          primary: true,
          render: (r) => (
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <FileIcon ext={r.ext} />
              <span>{r.name}</span>
            </Stack>
          ),
        },
        { header: 'SRB Code', nowrap: true, render: (r) => (r.srb ? <SrbCode code={r.srb} /> : '–') },
        { header: 'Type', render: (r) => r.type },
        { header: 'Source', render: (r) => r.source },
        {
          header: 'Status',
          nowrap: true,
          action: true,
          render: (r) => <StatusChip label={r.status} tone={DOC_STATUS_TONE[r.status]} />,
        },
        { header: 'Date', nowrap: true, render: (r) => shortDate(r.date) },
        {
          header: 'Actions',
          action: true,
          render: (r) =>
            canFinder ? (
              <Button
                size="small"
                variant="outlined"
                startIcon={<FolderOpenOutlined />}
                disabled={!r.path}
                onClick={(e) => {
                  e.stopPropagation();
                  notice(FINDER_NOTICE, 'info');
                }}
              >
                Open in Finder
              </Button>
            ) : null,
        },
      ]}
    />
  );
}
